<template>
  <div class="shop">
    <div class="top">
      <el-button size="small" type="primary" @click="exportPrivateOrder"
        >导出数据</el-button
      >
      <el-button
        class="search"
        size="small"
        type="primary"
        @click="searchOrderData"
        >搜索</el-button
      >
      <el-input
        class="search input"
        size="small"
        v-model="form.order_sn"
        placeholder="订单编号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.fans_mobile"
        placeholder="邀请人手机号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.shop_mobile"
        placeholder="店主手机号"
        clearable
      ></el-input>
      <el-input
        class="search input"
        size="small"
        v-model="form.user_mobile"
        placeholder="下单人手机号"
        clearable
      ></el-input>

      <el-date-picker
        v-model="form.end_time"
        class="picker"
        type="date"
        style="width:142px"
        size="small"
        value-format="yyyy-MM-dd"
        placeholder="选择结束时间"
      >
      </el-date-picker>
      <span class="guodu">~</span>
      <el-date-picker
        v-model="form.start_time"
        type="date"
        class="picker"
        style="width:142px"
        value-format="yyyy-MM-dd"
        size="small"
        placeholder="选择开始时间"
      ></el-date-picker>
    </div>
    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="订单编号" prop="order_sn"></el-table-column>
      <el-table-column label="店铺邀请人手机号" prop="fans_mobile"></el-table-column>
      <el-table-column label="商家手机号" prop="store_mobile"></el-table-column>
      <el-table-column label="商品信息" prop="goods_name"></el-table-column>
      <el-table-column label="下单用户" prop="user_mobile"></el-table-column>
      <el-table-column label="商品原价" prop="original_price"></el-table-column>
      <el-table-column
        label="实际红包抵扣"
        prop="total_fee"
      ></el-table-column>
      <el-table-column
        label="订单状态"
        prop="order_status_name"
      ></el-table-column>
      <el-table-column
        label="创建时间"
        prop="create_order_time"
      ></el-table-column>
      <el-table-column
        label="完成时间"
        prop="receive_time"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="200">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="toDetail(scope.row.order_id)"
            >详情</el-button
          >
          <el-button size="mini" @click="showOrderRemark(scope.row.order_id)"
            >备注</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
    <!--订单备注-->
    <jdialog title="订单备注" :visible.sync="isShowOrderremark" width="640px">
      <el-form
        :model="remarkform"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              color="#f4222d"
            >
              {{ activity.remarks }} {{ activity.created_at }}
            </el-timeline-item>
          </el-timeline>
          <el-input
            type="textarea"
            :rows="4"
            class="remarkarea"
            placeholder="请输入备注信息"
            v-model="remarkform.remarks"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div class="align">
        <el-button size="mini" @click="isShowOrderremark = false"
          >取消</el-button
        >
        <el-button size="mini" type="primary" @click="creatOrdeRemark"
          >确定</el-button
        >
      </div>
    </jdialog>
  </div>
</template>

<script>
// import uploadImg from "@/components/uploadImg";
import {
  memberOrder,
  memberOrderRemarks,
  creatOrderRemarks
} from '@/api/autarky'
// import {
//   createBanner,
//   getNewBannerList,
//   updateBanner,
//   deleteBanner
// } from '@/api/setting'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      loading: true,
      tableData: [],
      isShowOrderremark: false,
      form: {
        fans_mobile:'',
        user_mobile: '',
        shop_mobile: '',
        order_sn: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 20,
        is_export: ''
      },
      total: 0,
      remarkform: {
        order_id: '',
        remarks: ''
      },
      activities: []
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    //导出数据
    exportPrivateOrder() {
      if (this.loading) {
        this.loading = false
        this.form.is_export = 1
        this.getListData()
      }
    },
    //搜索
    searchOrderData() {
      this.getListData()
    },
    //获取列表数据
    async getListData() {
      let url = `page=${this.form.page}&user_mobile=${
        this.form.user_mobile
      }&shop_mobile=${this.form.shop_mobile}&order_sn=${
        this.form.order_sn
      }&fans_mobile=${
        this.form.fans_mobile
      }&start_time=${this.form.start_time}&end_time=${
        this.form.end_time
      }&is_export=${this.form.is_export}`
      let res = await memberOrder(url)
      if (res.code === 10000) {
        if (this.form.is_export == 1) {
          this.form.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          this.loading = true
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.form.is_export = 0
        this.$message.error(res.message)
      }
    },

    toDetail(order_id) {
      this.$router.push({
        path: './memberdetail',
        query: { orderId: order_id }
      })
    },
    //显示备注
    showOrderRemark(id) {
      console.log(id)
      this.remarkform.order_id = id
      this.remarkform.remarks = ''
      this.activities = []
      this.isShowOrderremark = true
      this.getOrdeRemark(id)
    },
    //获取订单备注创建
    async getOrdeRemark(id) {
      let res = await memberOrderRemarks({ order_id: id })
      if (res.code === 10000) {
        this.activities = res.data
        // this.$message.success(res.message)
      } else {
        this.$message.error(res.message)
      }
    },
    //创建订单备注创建
    async creatOrdeRemark() {
      let res = await creatOrderRemarks(this.remarkform)
      if (res.code === 10000) {
        this.$message.success(res.message)
        this.isShowOrderremark = false
      } else {
        this.$message.error(res.message)
      }
    },

    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getListData()
    },
    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .top {
    margin-bottom: 20px;
    .search {
      float: right;
      margin-left: 12px;
    }
    .input {
      width: 130px;
    }
    .picker {
      float: right;
    }
    .guodu {
      float: right;
      line-height: 30px;
    }
  }
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
